import { rudderstackTrack } from './rudderstackUtils';
export * from './rudderstackUtils';
export const trackAnalyticsEvent = (eventName, eventArgs) => {
    emitRudderstackEvent(eventName, eventArgs);
};
export const trackAnalyticsErrorEvent = (eventName, eventArgs) => {
    return emitRudderstackEvent(eventName, eventArgs);
};
export const emitRudderstackEvent = (eventName, eventArgs) => {
    rudderstackTrack(eventArgs, eventName);
};
//# sourceMappingURL=index.js.map